module.exports = __webpack_public_path__ + "img/四川天府新区第十一学校.a90fe025.jpg";